import { UserTypes } from './user.types';

const INITIAL_STATE = {
  "fullAddress": "",
  "placeID": "",
  "validAddress": false,
  "latitude": "-32.1631277", // Geographic centre of NSW
  "longitude": "147.0321395", // Geographic centre of NSW
  "alertMessage": "",
  "overlayIsVisible": false,
  "windToggleIsActive": false,
  "uniqueMapId": "",
  "pollutantPopupTypeId": "",
  "reloadStaticData": false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  let updatedState = {};

  switch (action.type) {
    case UserTypes.ADD_LOCATION:
      // Capture the current state
      updatedState = {
        ...state
      };

      // Only allow certain properties to be updated
      for (const prop in action.payload) {
        if (prop === "fullAddress") {
          updatedState.fullAddress = action.payload[prop];
        }
        if (prop === "placeID") {
          updatedState.placeID = action.payload[prop];
        }
        if (prop === "validAddress") {
          updatedState.validAddress = action.payload[prop];
        }
        if (prop === "latitude") {
          updatedState.latitude = action.payload[prop];
        }
        if (prop === "longitude") {
          updatedState.longitude = action.payload[prop];
        }
      }

      return updatedState;

    case UserTypes.SET_ALERT_MESSAGE:
      return {
        ...state,
        "alertMessage": action.payload
      };

    case UserTypes.SET_LOADING:
      return {
        ...state,
        "overlayIsVisible": action.payload
      };

    case UserTypes.SET_WIND_TOGGLE_TYPE:
      return {
        ...state,
        "windToggleIsActive": action.payload
      };

    case UserTypes.RESET_MAP:
      return {
        ...state,
        "uniqueMapId": action.payload
      };

    case UserTypes.SET_POLLUTANT_POPUP_TYPE:
      return {
        ...state,
        "pollutantPopupTypeId": action.payload
      };

    case UserTypes.SET_RELOAD_STATIC_DATA:
      return {
        ...state,
        "reloadStaticData": action.payload
      };

    default:
     return state;
  }
};

export default userReducer;
